<div
  bsModal
  #requestReviewModal="bs-modal"
  [config]="{
    show: false,
    keyboard: state && !state.modalControls.isSaving,
    ignoreBackdropClick: state?.modalControls.isSaving
  }"
  [rlTrapFocus]="{ setReturnFocus: '#edit-list-btn' }"
  (onHidden)="onHide()"
  class="c-modal modal fade"
  tabindex="-1"
  role="alertdialog"
  aria-labelledby="request-review-modal-heading"
  aria-describedby="request-review-modal-info"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <span class="fa-stack fa-5x" aria-hidden="true">
        <i class="fas fa-circle fa-stack-2x icon-bg-default"></i>
        <i class="far fa-clipboard-list fa-stack-1x t-brand-color"></i>
      </span>

      <h2
        id="request-review-modal-heading"
        class="qa-request-review-heading alpha"
        i18n="@@requestReviewModal-heading-requestReview"
      >
        Request review
      </h2>

      <div
        *ngIf="state.modalControls.savingError ? true : false"
        class="alert alert-danger qa-saving-error"
        role="alert"
      >
        <strong i18n="@@requestReviewModal-status-error">Error!</strong>
        <ng-container i18n="@@requestReviewModal-status-errorPleaseRetry"
          >There was an error requesting a review for your list. Please try
          again.</ng-container
        >
      </div>

      <p
        id="request-review-modal-info"
        class="qa-request-review-info"
        i18n="@@requestReviewModal-status-info"
      >
        To review student numbers associated with this list, select 'Hierarchy
        and student numbers' in the edit menu
      </p>

      <div class="c-modal__footer">
        <button
          type="button"
          class="btn btn-default qa-cancel-btn"
          i18n="@@requestReviewModal-btn-cancel"
          (click)="onHide()"
        >
          Cancel
        </button>
        <button
          [disabled]="state.modalControls.isSaving"
          (click)="onSend()"
          type="button"
          class="btn btn-primary qa-send-btn"
        >
          <ng-container *ngIf="state.modalControls.isSaving">
            <span class="text-center qa-saving-spinner" role="status">
              <i
                class="fas fa-spinner-third fa-fw fa-spin"
                aria-hidden="true"
              ></i>
              <span class="sr-only" i18n="@@requestReviewModal-spinner-saving"
                >Saving...</span
              >
            </span>
          </ng-container>

          <ng-container i18n="@@requestReviewModal-btn-send">Send</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
